// API client + auth helpers
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API_BASE,
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem('utc_token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export function setToken(token) {
    if (token) localStorage.setItem('utc_token', token);
    else localStorage.removeItem('utc_token');
}

export function getToken() {
    return localStorage.getItem('utc_token');
}

// Build an authenticated absolute URL for streamed media (<img>/<video> can't send headers).
// `path` is a backend path that already starts with '/api/...'. Appends ?auth=<jwt>.
export function mediaUrl(path) {
    if (!path) return '';
    const sep = path.includes('?') ? '&' : '?';
    return `${BACKEND_URL}${path}${sep}auth=${encodeURIComponent(getToken() || '')}`;
}
